import type { AircraftAsset, AircraftType, GameState } from '../game/types';

export const LEASE_MINIMUM_WEEKS = 4;
export const LEASE_DELIVERY_DELAY_WEEKS = 1;

export function leaseWeeklyPayment(type: AircraftType): number {
  return Math.round(type.weeklyFixedCost * 2.5 + type.price * 0.0012);
}

export function leaseDeposit(type: AircraftType): number {
  return leaseWeeklyPayment(type) * 2;
}

export function isAircraftDelivered(asset: AircraftAsset, week: number): boolean {
  return !asset.lease || week >= asset.lease.deliveryWeek;
}

export function idleDeliveredAircraft(game: GameState): AircraftAsset[] {
  return game.aircraft.filter((aircraft) => aircraft.routeIds.length === 0 && isAircraftDelivered(aircraft, game.week));
}
